import ForcePower from './forcepower';

export default ForcePower;
export { ForcePower };